// Predefined repair jobs with translations
export interface RepairJob {
  id: string;
  lv: string;
  en: string;
}

export const REPAIR_JOBS: RepairJob[] = [
  // Dzinējs un transmisija
  { id: 'engine_check', lv: 'Dzinēja pārbaude', en: 'Engine inspection' },
  { id: 'engine_repair', lv: 'Dzinēja remonts', en: 'Engine repair' },
  { id: 'engine_radiator_replacement', lv: 'Dzinēja radiatora maiņa', en: 'Engine radiator replacement' },
  { id: 'engine_power_increase', lv: 'Dzinēja jaudas palielināšana', en: 'Engine power increase' },
  { id: 'ecu_programming', lv: 'Vadības bloka (ECU) programmēšana un modificēšana', en: 'ECU programming and modification' },
  { id: 'drive_check', lv: 'Jaudas piedziņas pārbaude', en: 'Drive system inspection' },
  { id: 'drive_belt_replacement', lv: 'Piedziņas siksnas nomaiņa', en: 'Drive belt replacement' },
  { id: 'drive_shaft_replacement', lv: 'Piedziņas vārpstas nomaiņa', en: 'Drive shaft replacement' },
  { id: 'drive_shaft_guard_replacement', lv: 'Piedziņas vārpstas aizsargapvalka nomaiņa', en: 'Drive shaft guard replacement' },
  { id: 'drive_system_repair', lv: 'Piedziņas sistēmas remonts', en: 'Drive system repair' },
  { id: 'drive_shaft_differential_repair', lv: 'Piedziņas vārpstas un diferenciāļa remonts', en: 'Drive shaft and differential repair' },
  { id: 'manual_transmission_repair', lv: 'Mehāniskās ātrumkārbas remonts', en: 'Manual transmission repair' },
  { id: 'automatic_transmission_repair', lv: 'Automātiskās ātrumkārbas remonts', en: 'Automatic transmission repair' },
  { id: 'automatic_transmission_oil_change', lv: 'Eļļas maiņa automātiskajā ātrumkārbā', en: 'Automatic transmission oil change' },
  { id: 'clutch_kit_replacement', lv: 'Sajūga komplekta nomaiņa', en: 'Clutch kit replacement' },
  { id: 'clutch_basket_replacement', lv: 'Sajūga groza nomaiņa', en: 'Clutch basket replacement' },
  { id: 'clutch_plate_replacement', lv: 'Sajūga plāksnes nomaiņa', en: 'Clutch plate replacement' },
  { id: 'clutch_bearing_replacement', lv: 'Sajūga izspiedējgultņa nomaiņa', en: 'Clutch release bearing replacement' },
  { id: 'clutch_cable_replacement', lv: 'Sajūga troses maiņa', en: 'Clutch cable replacement' },
  { id: 'gas_cable_replacement', lv: 'Gāzes troses nomaiņa', en: 'Throttle cable replacement' },
  { id: 'handbrake_cable_replacement', lv: 'Stāvbremzes troses nomaiņa', en: 'Handbrake cable replacement' },
  
  // Blīves un sensori
  { id: 'exhaust_gasket', lv: 'Izpūtēja blīve', en: 'Exhaust gasket' },
  { id: 'valve_cover_gasket_replacement', lv: 'Vārstu vāka blīves maiņa', en: 'Valve cover gasket replacement' },
  { id: 'axle_shaft_seal_replacement', lv: 'Asu vārpstas blīves nomaiņa', en: 'Axle shaft seal replacement' },
  { id: 'cylinder_head_gasket_replacement', lv: 'Motora galvas blīves nomaiņa', en: 'Cylinder head gasket replacement' },
  { id: 'oil_pan_gasket_replacement', lv: 'Eļļas kartera blīves nomaiņa', en: 'Oil pan gasket replacement' },
  { id: 'oil_sensor_replacement', lv: 'Eļļas sensora nomaiņa', en: 'Oil sensor replacement' },
  { id: 'oil_temperature_sensor_replacement', lv: 'Eļļas temperatūras devēja maiņa', en: 'Oil temperature sensor replacement' },
  { id: 'oil_pressure_sensor_replacement', lv: 'Eļļas spiediena devēja maiņa', en: 'Oil pressure sensor replacement' },
  { id: 'ac_sensor_replacement', lv: 'AC sensora maiņa', en: 'AC sensor replacement' },
  { id: 'nox_sensor_replacement', lv: 'NOx sensora nomaiņa', en: 'NOx sensor replacement' },
  { id: 'abs_sensor_replacement', lv: 'ABS sensora nomaiņa', en: 'ABS sensor replacement' },
  { id: 'speed_sensor_replacement', lv: 'Ātruma sensora nomaiņa', en: 'Speed sensor replacement' },
  { id: 'speed_sender_replacement', lv: 'Ātruma devēja maiņa', en: 'Speed sender replacement' },
  { id: 'intake_manifold_pressure_sensor_replacement', lv: 'Ieplūdes kolektora spiediena sensora nomaiņa', en: 'Intake manifold pressure sensor replacement' },
  { id: 'intake_air_temperature_sensor_replacement', lv: 'Ieplūdes gaisa temperatūras sensora nomaiņa', en: 'Intake air temperature sensor replacement' },
  
  // Filtri un šķidrumi
  { id: 'dpf_filter_replacement', lv: 'DPF filtra nomaiņa', en: 'DPF filter replacement' },
  { id: 'air_filter_replacement', lv: 'Gaisa filtra maiņa', en: 'Air filter replacement' },
  { id: 'cabin_filter_replacement', lv: 'Salona filtra maiņa', en: 'Cabin filter replacement' },
  { id: 'fuel_filter_replacement', lv: 'Degvielas filtra maiņa', en: 'Fuel filter replacement' },
  { id: 'lpg_gas_filter_replacement', lv: 'LPG gāzes filtra nomaiņa', en: 'LPG gas filter replacement' },
  { id: 'engine_oil_change', lv: 'Dzinēja eļļas maiņa', en: 'Engine oil change' },
  { id: 'engine_oil_refill', lv: 'Dzinēja eļļas papildināšana', en: 'Engine oil refill' },
  { id: 'engine_oil_filter_change', lv: 'Dzinēja eļļas filtra maiņa', en: 'Engine oil filter change' },
  { id: 'tire_change', lv: 'Riepu maiņa', en: 'Tire change' },
  { id: 'tire_rotation', lv: 'Riepu rotācija', en: 'Tire rotation' },
  { id: 'tire_balancing', lv: 'Riepu balansēšana', en: 'Tire balancing' },
  { id: 'coolant_change', lv: 'Dzesēšanas šķidruma maiņa', en: 'Coolant/Antifreeze change' },
  { id: 'coolant_refill', lv: 'Dzesēšanas šķidruma papildināšana', en: 'Coolant/Antifreeze refill' },
  { id: 'brake_fluid_change', lv: 'Bremžu šķidruma maiņa', en: 'Brake fluid change' },
  { id: 'brake_fluid_refill', lv: 'Bremžu šķidruma papildināšana', en: 'Brake fluid refill' },
  
  // Balstiekārta un bremzes
  { id: 'suspension_installation', lv: 'Balsta uzstādīšana', en: 'Suspension installation' },
  { id: 'suspension_repair', lv: 'Balstiekārtas remonts', en: 'Suspension repair' },
  { id: 'suspension_verification', lv: 'Balstiekārtas verifikācija', en: 'Suspension verification' },
  { id: 'suspension_arm_replacement', lv: 'Balstiekārtas sviras nomaiņa', en: 'Suspension arm replacement' },
  { id: 'suspension_silent_block_replacement', lv: 'Balstiekārtas sailentbloku maiņa', en: 'Suspension silent block replacement' },
  { id: 'brake_system_check', lv: 'Bremžu sistēmas pārbaude', en: 'Brake system inspection' },
  { id: 'brake_regulator_replacement', lv: 'Bremžu regulētāja nomaiņa', en: 'Brake regulator replacement' },
  { id: 'brake_cylinder_replacement', lv: 'Bremžu cilindru nomaiņa', en: 'Brake cylinder replacement' },
  { id: 'brake_drum_replacement', lv: 'Bremžu trumuļa nomaiņa', en: 'Brake drum replacement' },
  { id: 'metal_brake_line_replacement', lv: 'Metāla bremžu caurules nomaiņa', en: 'Metal brake line replacement' },
  { id: 'braided_brake_line_installation', lv: 'Pīto bremžu cauruļu uzstādīšana', en: 'Braided brake line installation' },
  
  // Ieplūdes un izplūdes sistēma
  { id: 'exhaust_muffler_replacement', lv: 'Izplūdes izpūtēja nomaiņa', en: 'Exhaust muffler replacement' },
  { id: 'exhaust_system_repair', lv: 'Izplūdes sistēmas remonts', en: 'Exhaust system repair' },
  { id: 'exhaust_manifold_replacement', lv: 'Izplūdes kolektora nomaiņa', en: 'Exhaust manifold replacement' },
  { id: 'exhaust_manifold_gasket_replacement', lv: 'Izplūdes kolektora blīves maiņa', en: 'Exhaust manifold gasket replacement' },
  { id: 'exhaust_center_pipe_replacement', lv: 'Izplūdes centra caurules nomaiņa', en: 'Exhaust center pipe replacement' },
  { id: 'exhaust_system_verification', lv: 'Izplūdes sistēmas verifikācija', en: 'Exhaust system verification' },
  { id: 'intake_manifold_replacement', lv: 'Ieplūdes kolektora nomaiņa', en: 'Intake manifold replacement' },
  { id: 'intake_system_repair', lv: 'Ieplūdes sistēmas remonts', en: 'Intake system repair' },
  { id: 'intake_manifold_gasket_replacement', lv: 'Ieplūdes kolektora blīves maiņa', en: 'Intake manifold gasket replacement' },
  { id: 'air_intake_pipe_replacement', lv: 'Gaisa ieplūdes caurules maiņa', en: 'Air intake pipe replacement' },
  
  // Atjaunošanas un papildu darbi
  { id: 'starter_rebuild', lv: 'Startera atjaunošana', en: 'Starter rebuild' },
  { id: 'alternator_rebuild', lv: 'Ģeneratora atjaunošana', en: 'Alternator rebuild' },
  { id: 'main_bearing_rebuild', lv: 'Pamatlukturu atjaunošana', en: 'Main bearing rebuild' },
  { id: 'turbo_rebuild', lv: 'Turbokompresoru atjaunošana', en: 'Turbo rebuild' },
  { id: 'abs_pump_rebuild', lv: 'ABS sūkņa atjaunošana', en: 'ABS pump rebuild' },
  
  // Braukšanas un drošības sistēmas
  { id: 'driving_support_systems_1', lv: 'Braukšanas atbalsta sistēmas – ACD, EDS', en: 'Driving support systems – ACD, EDS' },
  { id: 'driving_support_systems_2', lv: 'Braukšanas atbalsta sistēmas – TSR, ACC, BLIS, AFS, LDW, HHC, SBR', en: 'Driving support systems – TSR, ACC, BLIS, AFS, LDW, HHC, SBR' },
  { id: 'accident_warning_systems', lv: 'Negadījumu brīdinājuma sistēmas – AHR, ACS', en: 'Accident warning systems – AHR, ACS' },
  { id: 'adaptive_cruise_control_calibration', lv: 'Adaptīvās kruīza kontroles sistēmas (ACC) kalibrēšana', en: 'Adaptive cruise control (ACC) calibration' },
  
  // Gāzes iekārtas (LPG)
  { id: 'lpg_evaporator_replacement', lv: 'LPG iztvaicētāja nomaiņa', en: 'LPG evaporator replacement' },
  { id: 'lpg_valve_replacement', lv: 'LPG vārstu nomaiņa', en: 'LPG valve replacement' },
  { id: 'lpg_electrovalve_replacement', lv: 'LPG elektrovārstu nomaiņa', en: 'LPG electrovalve replacement' },
  { id: 'lpg_hose_replacement', lv: 'LPG šļaukas nomaiņa', en: 'LPG hose replacement' },
  { id: 'lpg_tank_certification', lv: 'LPG tvertņu sertifikācija', en: 'LPG tank certification' },
];

/**
 * Filter repair jobs based on query (minimum 3 characters)
 * Searches in both current language and Latvian
 */
export function filterRepairJobs(query: string, language: 'en' | 'lv'): RepairJob[] {
  if (query.length < 3) return [];
  
  const lowerQuery = query.toLowerCase();
  
  return REPAIR_JOBS.filter(job => {
    const currentLangText = job[language].toLowerCase();
    const latvianText = job.lv.toLowerCase();
    
    // Match in current language or Latvian (for users typing in either)
    return currentLangText.includes(lowerQuery) || latvianText.includes(lowerQuery);
  });
}

